'use client';

import { useIntersectionObserver } from '@/lib/hooks';
import { cn } from '@/lib/utils';
import TextHuge from '../ui/TextHuge';

export default function Section({
    id,
    title,
    children,
    className,
    titleColor = 'black',
    titleClassName,
    containerClassName,
}: {
    id?: string;
    title?: string;
    children: React.ReactNode;
    className?: string;
    titleColor?: 'black' | 'white';
    titleClassName?: string;
    containerClassName?: string;
}) {
    const [sectionRef, isObserved] = useIntersectionObserver({ threshold: 0.1 });

    return (
        <section
            className={cn('w-full relative pt-28 pb-16 bg-bg-100', className)}
            ref={sectionRef}
            id={id}
        >
            <div className="flex max-lg:flex-col">
                {title && (
                    <TextHuge
                        className={cn(
                            'uppercase lg:top-10 z-1 w-fit leading-none lg:sticky lg:[writing-mode:vertical-rl] lg:rotate-180 xl:h-full max-lg:pl-5 lg:pr-5 max-lg:pb-7 lg:text-center translate-y-1/4 transition-all lg:duration-2000 duration-1000 delay-500 invisible opacity-0 text-nowrap h-fit',
                            titleColor === 'black' ? 'text-gray-200' : 'text-gray-100',
                            isObserved && 'translate-y-0 visible opacity-100',
                            titleClassName,
                            'w-44',
                        )}
                    >
                        {title}
                    </TextHuge>
                )}
                <div className={cn('w-full', containerClassName)}>{children}</div>
            </div>
        </section>
    );
}
